import "./ServiceProjectCard.css";

const ServiceProjectCard = ({
  category,
  title,
  description,
  image,
  buttonText = "View Details",
  onViewDetails,
}) => {
  return (
    <div className="service-project-card">

      <div className="service-project-image">

        <img src={image} alt={title} />

        <div className="service-project-category">
          {category}
        </div>

      </div>

      <div className="service-project-content">

        <h2>{title}</h2>

        <p>{description}</p>

        <button
          className="service-project-button"
          onClick={onViewDetails}
        >
          {buttonText}
          <span className="arrow">→</span>
        </button>

      </div>

    </div>
  );
};

export default ServiceProjectCard;